'use client'

import React, { useEffect, useRef } from 'react'
import styles from './IFrameResizer.module.scss'

export type IframeResizedData = {
  width: string
  height: string
  iframe: HTMLIFrameElement
}

declare global {
  interface Window {
    // @ts-ignore
    iFrameResize: Function | undefined
  }
}

const IframeResizer = ({
  src,
  title,
  loading,
  onResized,
  height,
}: {
  src: string
  title?: string
  loading?: 'lazy' | 'eager'
  onResized?: (data: IframeResizedData) => void
  height?: string
}) => {
  // script is loading via widgets\metadata\components\ScriptGlobal.tsx
  const iframeRef = useRef(null)

  useEffect(() => {
    if (window.iFrameResize) {
      if (onResized) {
        window.iFrameResize(
          {
            onResized: function (data: IframeResizedData) {
              onResized(data)
            },
          },
          iframeRef.current,
        )
      } else {
        window.iFrameResize(iframeRef.current)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <iframe
      className={styles.iframe}
      ref={iframeRef}
      src={src}
      title={title || ''}
      width="100%"
      height={height || '0'}
      loading={loading || 'lazy'}
      scrolling="no"
      frameBorder="0"
    />
  )
}

export default IframeResizer
